import "./base.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};

AppointmentBooking.Wizard.Views.Progress = class Progress extends AppointmentBooking.Wizard.Views.Base {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.contextForRender = this.contextForRender.bind(this);
  }

  initialize() {
    return this.listenTo(this.model, "change:currentStepProgress change:currentStepIndex change:steps", this.render);
  }

  // EVENT HANDLERS

  handlePastStepClick(event) {
    const stepIndex = jQuery(event.currentTarget).data("step-index");
    return this.triggerEvent(AppointmentBooking.Wizard.Events.Progress.jumpToStepClicked, stepIndex);
  }

  // PRIVATE

  contextForRender() {
    const stepLabels = this.model
      .get("steps")
      .map((step) => AppointmentBooking.Wizard.Views.Step.lookup(step).prototype.name);

    return {
      currentStepIndex: this.model.get("currentStepIndex"),
      currentStepProgress: this.model.get("currentStepProgress"),
      stepLabels,
    };
  }
};
AppointmentBooking.Wizard.Views.Progress.prototype.tagName = "div";
AppointmentBooking.Wizard.Views.Progress.prototype.template = "progress";
AppointmentBooking.Wizard.Views.Progress.prototype.className = "appointment-booking-wizard-progress";
AppointmentBooking.Wizard.Views.Progress.prototype.events = { "click .step.past": "handlePastStepClick" };
